import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('avartana_token');
    localStorage.removeItem('avartana_user');
    setUser(null);
  }, []);

  // Restore session on mount
  useEffect(() => {
    const token     = localStorage.getItem('avartana_token');
    const savedUser = localStorage.getItem('avartana_user');

    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        logout();
        setLoading(false);
        return;
      }
      authAPI.me()
        .then(res => {
          setUser(res.data.user);
          localStorage.setItem('avartana_user', JSON.stringify(res.data.user));
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [logout]);

  // Login — never pass role, let backend resolve it
  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { token, user: loggedInUser } = res.data;
    localStorage.setItem('avartana_token', token);
    localStorage.setItem('avartana_user', JSON.stringify(loggedInUser));
    setUser(loggedInUser);
    return loggedInUser;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    const { token, user: newUser } = res.data;
    localStorage.setItem('avartana_token', token);
    localStorage.setItem('avartana_user', JSON.stringify(newUser));
    setUser(newUser);
    return newUser;
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('avartana_user', JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
};
